import { SDKOperationInstance } from "@extrimian/identity-wallet";

export class GetContent {
    RootObjectId: number
    language: string;
    fromAddress: string;
    state: SDKOperationInstance
}

export class GetContentWithoutWallet {
    BidId?: number
    RootObjectId: number
    language: string;
    fromAddress: string;
}

export interface SignatureResponse {
    sdkCommunicationMessage: any;
    signatureId: string;
}
